interface IcardTitle {
    title:string
}

export const CardTitle = ({title}:IcardTitle) => {
  return(
  <div className="flex items-center justify-start md:justify-between gap-4 mt-6 p-7">
    <p className="text-2xl text-white font-bold fontTitle w-[140px]">
      {title}
    </p>

  <div className="flex-1 border-t-2 border-gray-700"></div>
</div>
  )

}